import type { ReactNode } from 'react'
import { NativeBridge, type NativeFrameConfig } from '@dhl/native-bridge'
import { createPalette, useColorScheme } from '@dhl/theme'
import { getConfig } from './config'

type Props = {
  children: ReactNode
}

const { environment } = getConfig()

const lightPalette = createPalette('light')

const nativeFrame: NativeFrameConfig = {
  defaultStatusBarColor: 'brand',
  // this always needs to be secondary light from the light palette, since the account app doesn't use DS yet
  defaultFooterColor: { light: lightPalette.secondary.light, dark: lightPalette.secondary.light },
}

export const AccountNativeBridge = ({ children }: Props) => {
  const { preferredColorScheme, setPaletteMode } = useColorScheme()

  return (
    <NativeBridge
      disableBackSwipeOn={['/sign-in']}
      isProduction={environment === 'production'}
      nativeFrame={nativeFrame}
      theme={{ preferredColorScheme, setPaletteMode }}
    >
      {children}
    </NativeBridge>
  )
}
